module.exports = __webpack_public_path__ + "img/bg_avatar_female_50.4734530a.png";